import { useQuery } from 'react-query';
import { organizationKeys } from '@config/queryKeys';

import type { OrganizationBusinessInfo } from '../types/organizations';

import { useOrganizationApi } from './api';

type Options = {
  organizationId?: string;
};
export default function useOrganizationBusinessInfo({
  organizationId = '',
}: Options = {}) {
  const api = useOrganizationApi();
  const { data, isFetched, isFetching, isLoading, refetch } =
    useQuery<OrganizationBusinessInfo>(
      organizationKeys.businessInfo(organizationId),
      () => api.getBusinessInfo(organizationId),
      {
        enabled: !!organizationId,
      }
    );

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    businessInfo: data ?? ({} as OrganizationBusinessInfo),
  };
}
